import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import schools from './modules/schools';
import website from './modules/website';
import users from './modules/users';
import general from './modules/general';
import admin from './modules/admin';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with
  // only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if
  // it should update the state in localStorage.
  // filter: mutation => (true)
});

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    users,
    schools,
    website,
    general,
    admin,
  },
  strict: false,
  plugins: debug ? [vuexLocalStorage.plugin] : [vuexLocalStorage.plugin],
});



// WEBPACK FOOTER //
// ./src/store/index.js